import { PriceLegend as ShopPriceLegend } from '@shop/frontend/web/js/components/PriceLegend';
import { translator } from '@shop/frontend/web/js/services/TranslatorService';
import { helpers } from '@shop/frontend/web/js/helpers';

class PriceLegend extends ShopPriceLegend {
  /**
   * Создает легенды цен
   * @param zones {Array} [
   *   {zone, price, color, free, all}, ...
   * ]
   * @param params {Object} { showFreePlaces }
   */
  render(zones = [], params = {}) {
    this.$container.html('');

    const seatsEndings = [
      translator.t('event', 'seat'),
      translator.t('event', 'seats'),
      translator.t('event', 'seats '),
    ];

    if (params.joinEqualPrices) zones = this.joinZonesByEqualPrices(zones);

    zones.sort((a, b) => a.price - b.price);
    $.each(zones, (i, zone) => {
      const freeText = ` ${translator.t('main', 'left')} ${zone.free} ${helpers.wordEnding(
        zone.free,
        seatsEndings,
      )}`;

      const legend = params?.isPlaces
        ? this.createPriceLegendPlacesByZone(zone, {
          usePrimaryColor: !!params.usePrimaryColor,
          freeText: params.showFreePlaces ? freeText : '',
        })
        : this.createPriceLegendSectorsByZone(zone, {
          usePrimaryColor: !!params.usePrimaryColor,
          freeText: params.showFreePlaces ? freeText : '',
        });

      this.$container.append(
        legend,
      );
    });

    if (!helpers.isDesktop.matches && params.mobileLastSlot) this.$container.append(params.mobileLastSlot);

    this.addListenerToInputs();
    $('[data-toggle="tooltip"], .js-toggle-tooltip').tooltip({
      html: true,
    });
  }

  createPriceLegendSectorsByZone(zone, params = {}) {
    return `<label 
              class="price-legend ${params.usePrimaryColor ? 'price-legend_primary' : ''}"
              style="border-color: ${zone.color}"
            >
              <input class="price-legend__input" type="checkbox" data-price="${zone.price}" data-zone-id="${zone.zone}">
              <span class="price-legend__content">
                <span class="price-legend__color" style="background-color: ${zone.color}"></span>
                <span class="price-legend__text">
                  <p class="mb-0">${`${zone.price} <span class="ruble">₽</span>`
      + `${zone.name ? `, ${zone.name}` : ''}</p>`
      + `<p class="price-legend__text_free">${params.freeText ? params.freeText : ''} ${this.getZoneInfoIcon(zone.name.toString().toLowerCase())}</p>`}
                </span>
              </span>
            </label>`;
  }

  createPriceLegendPlacesByZone(zone, params = {}) {
    return `<label 
              class="price-legend ${params.usePrimaryColor ? 'price-legend_primary' : ''}"
              style="border-color: ${zone.color}"
            >
              <input class="price-legend__input" type="checkbox" data-price="${zone.price}" data-zone-id="${zone.zone}">
              <span class="price-legend__content">
                <span class="price-legend__place" style="background-color: ${zone.color}"></span>
                <span class="price-legend__text">
                  <p class="mb-0">${`${zone.price} <span class="ruble">₽</span></p>`
      + `<p class="price-legend__text_free">${params.freeText ? params.freeText : ''}</p>`}
                </span>
              </span>
            </label>`;
  }

  getZoneInfoIcon(name) {
    const text = this.getZoneInfoTooltipText(name);
    if (text) {
      return `<span class="price-legend__zone-info"
                  data-toggle="tooltip"
                  data-html="true"
                  title="<div class='tooltip-left'>${text}</div>">?</span>`;
    }
    return '';
  }

  getZoneInfoTooltipText(name) {
    if (name === 'семейный сектор') {
      return `
      <div><strong>Семейный Сектор:</strong></div>
      <div>1. Комфортабельные кресла</div>
      <div>2. Теплое помещение</div>
      <div>3. Игровая комната</div>
      <div>4. Кафе</div>
    `;
    }

    if (name === 'теплый сектор') {
      return `
      <div><strong>Теплый Сектор:</strong></div>
      <div>1. Комфортабельные кресла</div>
      <div>2. Теплое помещение</div>
      <div>3. Кафе</div>
    `;
    }

    if (name === 'vip') {
      return `
      <div><strong>Vip:</strong></div>
      <div>1. Отдельный VIP-вход</div>
      <div>2. Застекленная теплая зона</div>
      <div>3. Ресторан</div>
      <div>4. Идеальный вид на поле</div>
      <div>5. Точка продаж атрибутики</div>
    `;
    }

    if (name === 'мгн') {
      return `
      <div><strong>МГН:</strong></div>
      <div>МГН места, предназначены для граждан с 1 и 2 группой инвалидности.</div>
    `;
    }

    return false;
  }
}

export default PriceLegend;
